(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ugc-shop-the-look-router"]) return;
  try {
    
  (function () {
    function findLookTemplate(router, requestedHandle) {
      var templates = router.querySelectorAll('template[data-ugc-look-template]');

      return Array.prototype.find.call(templates, function (template) {
        return template.dataset.ugcLookTemplate.toLowerCase() === requestedHandle;
      });
    }

    function activateLook(router) {
      if (router.dataset.ugcLookRouterInitialized === 'true') return;

      router.dataset.ugcLookRouterInitialized = 'true';

      var requestedHandle = new URLSearchParams(window.location.search).get('look');
      if (!requestedHandle) return;
      requestedHandle = requestedHandle.trim().toLowerCase();

      var template = findLookTemplate(router, requestedHandle);
      if (!template) return;

      router.appendChild(template.content.cloneNode(true));
    }

    function init(scope) {
      scope.querySelectorAll('[data-ugc-look-router]').forEach(activateLook);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
